<template>
    <div  class="contact-me" style="text-align: center;width: 100%">
        <!-- ============= 顶部背景图 ============= -->
        <div>
            <img src="../../assets/images/about/contact.png" style="width: 100%;display: block">
        </div>

        <!-- ============= 公司分部 ============= -->
        <div class="contact-company" style="height: 80px;width: 100%;line-height:30px;background-color: #F0F0F0;text-align: center">
            <ul style="list-style-type:none;cursor:pointer;line-height: 80px;text-align: center;margin: 0 auto;padding: 0;height: 80px;width: 900px;background-color: #F0F0F0">
              <li v-for="(item,index) in items" :key="index" :class="{'selected':flag == index}" style="float: left;height: 80px;width: 300px;font-size: 24px" @click="getCompanyDetaile(index)">{{item.title}}</li>
            </ul>
        </div>

        <!-- ============= 分部地理位置 ============= -->
        <div style="height: auto;width: 99%">
          <iframe v-show="shangHaiShow" style="width: 100%;height: 720px;"  scrolling="no"  src="../../static/shmap.html"></iframe>
          <iframe v-show="xiangGangShow" style="width: 100%;height: 720px;"  scrolling="no"  src="../../static/hkmap.html"></iframe>
          <iframe v-show="shenzhenShow" style="width: 100%;height: 720px;"  scrolling="no"  src="../../static/szmap.html"></iframe>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                shangHaiShow: true,
                xiangGangShow: false,
                shenzhenShow: false,
                flag: -1,
                items: [{title:'Shanghai'},{title: 'HongKong'},{title: 'Shengzhen'}],
            }
        },
        mounted:function(){
            this.getCompanyDetaile(0);
        },
        methods: {
            getCompanyDetaile:function (index) {
                this.flag = index;
                if(index === 0){
                    this.shangHaiShow = true;
                    this.xiangGangShow = false;
                    this.shenzhenShow = false;
                } else if (index === 1){
                    this.shangHaiShow = false;
                    this.xiangGangShow = true;
                    this.shenzhenShow = false;
                } else if (index === 2){
                    this.shangHaiShow = false;
                    this.xiangGangShow = false;
                    this.shenzhenShow = true;
                }
            }
        },
    }
</script>

<style >
  .contact-me .contact-company  { }
  .contact-me .contact-company  .homes-solution-li:hover { background-color: #fff }
  .contact-me .selected { background-color: #fff }
</style>



// WEBPACK FOOTER //
// src/pages/about/contact.vue